import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SinpeService {
  private totalPagarSubject = new BehaviorSubject<{
    total: string;
    sinpes: { codReferencia: string; monto: number }[];
  }>({ total: '', sinpes: [] });

  private seleccionadasSubject = new BehaviorSubject<
    { codReferencia: string; monto: number }[]
  >([]);
  private operacionesSubject = new BehaviorSubject<any[]>([]);
  private valoresFormSubject = new BehaviorSubject<{
    tipoCedula: string;
    numDocumento: string;
  } | null>(null);

  private respuestaVinculacionSubject = new BehaviorSubject<any>(null);

  totalPagar$ = this.totalPagarSubject.asObservable();
  seleccionadas$ = this.seleccionadasSubject.asObservable();
  respuestaVinculacion$ = this.respuestaVinculacionSubject.asObservable();
  operaciones$ = this.operacionesSubject.asObservable();
  valoresForm$ = this.valoresFormSubject.asObservable();

  emitirTotalPagar(
    valor: string,
    sinpes: { codReferencia: string; monto: number }[] = []
  ) {
    this.totalPagarSubject.next({ total: valor, sinpes });
    this.seleccionadasSubject.next(sinpes);
  }

  guardarSeleccion(sinpes: { codReferencia: string; monto: number }[]) {
    this.seleccionadasSubject.next(sinpes);
  }

  getTotalPagar(): number {
    const getTotal = this.convertirMonedaANumero(
      this.totalPagarSubject.getValue().total
    );
    return getTotal;
  }

  getSinpes() {
    return this.totalPagarSubject.getValue().sinpes;
  }

  getSeleccionadas() {
    return this.seleccionadasSubject.getValue();
  }

  setRespuestaVinculacion(respuesta: any) {
    this.respuestaVinculacionSubject.next(respuesta);
  }

  getRespuestaVinculacion() {
    return this.respuestaVinculacionSubject.getValue();
  }

  convertirMonedaANumero(monto: string): number {
    return parseFloat(monto.replace(/[^\d,.-]/g, '').replace(',', '.'));
  }

  guardarOperaciones(operaciones: any[]) {
    this.operacionesSubject.next(operaciones);
  }

  getOperaciones(): any[] {
    return this.operacionesSubject.getValue();
  }

  guardarValoresForm(valores: { tipoCedula: string; numDocumento: string }) {
    this.valoresFormSubject.next(valores);
  }

  obtenerValoresForm() {
    return this.valoresFormSubject.getValue();
  }

  resetearEstado() {
    this.totalPagarSubject.next({ total: '', sinpes: [] });
    this.seleccionadasSubject.next([]);
    this.operacionesSubject.next([]);
    this.valoresFormSubject.next(null);
    this.respuestaVinculacionSubject.next(null);
  }
}
